import { createContext, useContext, useMemo } from "react";
import type { ToastAction } from "./Toast.tsx";

export interface ToastContent {
    variant: "success" | "error";
    message: string;
    size?: "normal" | "wide";
    action?: ToastAction;
    durationInMs?: number;
}

export interface ShowToastOptions {
    durationInMs?: number;
    size?: "normal" | "wide";
    action?: ToastAction;
}

export const TOAST_DURATION_MS = {
    confirmation: 4000,
    actionable: 8000
} as const;

export const ToastContext = createContext<(content: ToastContent) => void>(() => {});

export function useToast() {
    const dispatch = useContext(ToastContext);

    return useMemo(
        () => ({
            success: (message: string, { durationInMs, size, action }: ShowToastOptions = {}) => {
                dispatch({
                    variant: "success",
                    message,
                    size,
                    action,
                    durationInMs:
                        durationInMs ?? (action ? TOAST_DURATION_MS.actionable : TOAST_DURATION_MS.confirmation)
                });
            },
            error: (message: string, { durationInMs, size, action }: ShowToastOptions = {}) => {
                dispatch({
                    variant: "error",
                    message,
                    size,
                    action,
                    durationInMs:
                        durationInMs ?? (action ? TOAST_DURATION_MS.actionable : TOAST_DURATION_MS.confirmation)
                });
            }
        }),
        [dispatch]
    );
}
